<template>
  <div class="field">
    <div class="field-label is-normal" v-if="config.label">
      <label class="label">{{config.label}}</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <div class="select is-fullwidth" :class="{'is-loading': config.options.length === 0}">
            <select
              @change="updateValue($event.target.value)"
              :value="config.default ? 'default' : config.value"
            >
              <option v-if="config.default" value="default" disabled selected>{{config.default}}</option>
              <option
                v-for="option in config.options"
                :value="option.value"
                :key="option.value"
                :selected="option.value === config.value"
              >{{option.label}}</option>
            </select>
          </div>
        </div>
                  <span class="label-error" v-if="config.error">{{config.message}}</span>

      </div>
    </div>
  </div>
</template>
<style  lang="scss" >
@import "./src/bulma/form/select";
</style>
<script lang="ts">
// @ is an alias to /src
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { ISelect } from './';

@Component({
  name: 'Select'
})
class Select extends Vue {
  @Prop({ required: true }) public config!: ISelect;
  @Prop({ required: true }) public value!: string;

  @Watch('config') public onConfigChanges() {
    this.$emit('input', this.config.value);
  } public created() {
    this.$emit('input', this.config.value);
  }
  public updateValue(value: string | number) {
    this.$emit('input', value);
  }
}
export default Select;
</script>